import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { reportRoutingModule } from './reports-routing.module';
import { SharedModule } from 'src/app/middleware/shared/shared.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatTabsModule} from '@angular/material/tabs';
import { MatTableModule} from '@angular/material/table';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule, MatSelectTrigger } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDialogModule } from '@angular/material/dialog';
import { DragDropModule} from '@angular/cdk/drag-drop';
import { MatListModule } from '@angular/material/list';
import { ApiEndPointsSettings } from './common/apiUrls/api-end-points-settings';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/middleware/common/common.service';
import { AddFieldsVM,AddEditGroupVm, ReorderPositionVm } from 'src/app/viewModels/core/add-fields-vm';
import { AddFolderVM } from 'src/app/viewModels/core/add-folder-vm';
import { AddSubFolderVM } from 'src/app/viewModels/core/add-sub-folder-vm';
import { NestableModule } from 'ngx-nestable';
import { MatRadioModule } from '@angular/material/radio';
import { SideNavigationComponent } from './side-navigation/side-navigation.component';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { MatAutocompleteModule} from '@angular/material/autocomplete';
import { MatChipsModule} from '@angular/material/chips';
import { MatSliderModule} from '@angular/material/slider';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { Interceptor } from 'src/app/middleware/authentication/interceptor/auth-interceptor';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { MultiselectVM } from 'src/app/viewModels/common/multiselect-vm';
import { MatSortModule } from '@angular/material/sort';
import { ClipboardModule} from '@angular/cdk/clipboard';
import { CKEditorModule } from 'ckeditor4-angular';
import { MatTreeModule } from '@angular/material/tree';
import { ManageAutomationProcessReportComponent } from './manage-AutomationProcessReport/manage-AutomationProcessReport.component';
import { ManageFormUseReportComponent } from './manage-FormUseReports/manage-FormUseReports.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReportService } from './services/reportService/report.service';
import { ManageProjectStatusReportComponent } from './manage-ProjectStatusReports/manage-ProjectStatusReports.component';
import { ManageProjectDataReportComponent } from './manage-ProjectDataReports/manage-ProjectDataReports.component';


@NgModule({
  declarations: [ReportsComponent,SideNavigationComponent,
    ManageAutomationProcessReportComponent,ManageFormUseReportComponent,
    ManageProjectStatusReportComponent,ManageProjectDataReportComponent],
  imports: [
    ClipboardModule,
    CommonModule,
    reportRoutingModule,
    SharedModule,
    FlexLayoutModule,
    MatTabsModule,
    MatTableModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatSlideToggleModule,
    MatDialogModule,
    DragDropModule,
    MatSlideToggleModule,
    MatListModule,
    NestableModule,
    MatSortModule,
    MatRadioModule,
    MatCardModule,
    RouterModule,
    MatAutocompleteModule,
    MatChipsModule,
    MatSliderModule,
    MatProgressSpinnerModule,
    CKEditorModule,
    MatTreeModule,
    MatDatepickerModule,
    NgMultiSelectDropDownModule.forRoot()
  ],
  providers: [
    AddFolderVM,
    ApiEndPointsSettings,
    ReportService,
    EncryptionService,
    ReusableClasses,
    StatusConstant,
    LoaderService,
    ToastrService,
    AddSubFolderVM,
    CommonService,
    AddFieldsVM,
    ReorderPositionVm,
    AddEditGroupVm,
    MultiselectVM,
    DatePipe,
    {provide: HTTP_INTERCEPTORS, useClass: Interceptor, multi: true},
  ]
})
export class ReportsModule { }
